import { render, staticRenderFns } from "./ReviewCatalog.vue?vue&type=template&id=7bf7878e&scoped=true&"
import script from "./ReviewCatalog.vue?vue&type=script&lang=js&"
export * from "./ReviewCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCatalog.vue?vue&type=style&index=0&id=7bf7878e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf7878e",
  null
  
)

export default component.exports